import ApplicationAdapter from 'eflex/adapters/application';

export default class AreaAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
